import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import KML from 'ol/format/KML';
import {Heatmap as HeatmapLayer, Tile as TileLayer} from 'ol/layer';
import Stamen from 'ol/source/Stamen';
import VectorSource from 'ol/source/Vector';
import {add} from 'ol/coordinate';

var map = new ol.Map({
    layers: [
        new ol.layer.Tile({
        source: new ol.source.OSM()
        }),
    ],
    target: 'map',
    controls: ol.control.defaults({
        attributionOptions: /** @type {olx.control.AttributionOptions} */ ({
        collapsible: false
        })
    }),
    view: new ol.View({
        center: [0, 0],
        zoom: 2
    }),
    interactions: ol.interaction.defaults().extend([
        new ol.interaction.DragRotateAndZoom(),
        new ol.interaction.PinchRotate(),
    ])
    });

    // created for owl range of data
    var data = new ol.source.Vector();
    var coord = ol.proj.fromLonLat([-6.2158121, 106.8051012]);  // Barcelona, Spain
    var lonLat = new ol.geom.Point(coord);
    var pointFeature = new ol.Feature({
    geometry: lonLat,
    weight: 20 // e.g. temperature
    });
    data.addFeature(pointFeature);

    // create the layer
    heatMapLayer = new ol.layer.Heatmap({
    source: data,
    radius: 50
});

// add to the map
map.addLayer(heatMapLayer);
